import { useState } from 'react'

import { AddressSelect as AddressSelectComponent } from '../../../Address'
import {
  getInitialGoogleMapModalValues,
  GoogleMapApiProvider,
  GoogleMapModal,
} from '../../../Google'
import { Container } from '../../Container'

function AddressSelect() {
  const [showAddressModal, setShowAddressModal] = useState(false)
  const [selectValue, setSelectValue] = useState(null)

  function handleShowMap() {
    setShowAddressModal(true)
  }

  function handleCloseAddressModal() {
    setShowAddressModal(false)
  }

  function handleSubmitAddressForm(value) {
    setSelectValue(value)

    setShowAddressModal(false)
  }

  return (
    <GoogleMapApiProvider>
      <Container label='Address select'>
        <AddressSelectComponent
          value={selectValue}
          onChangeSearch={setSelectValue}
          onSelectItem={setSelectValue}
          onShowMap={handleShowMap}
        />
      </Container>
      {showAddressModal ? (
        <GoogleMapModal
          editMode
          addressSelectProps={{
            maxLength: 500,
          }}
          buttonText='Modal.BuildingSaveAddressBtnKey'
          initialValues={getInitialGoogleMapModalValues(selectValue)}
          title='Modal.AddAddressTitleKey'
          onClose={handleCloseAddressModal}
          onSubmit={handleSubmitAddressForm}
        />
      ) : null}
    </GoogleMapApiProvider>
  )
}

export default AddressSelect
